import AppContext from "@/AppContext";
import StepOne from "@/components/startup/registration/step-1";
import StepTwo from "@/components/startup/registration/step-2";
import StepThree from "@/components/startup/registration/step-3";
import useAuth from "@/hooks/auth";
import { useRouter } from "next/router";
import { useContext, useEffect } from "react";

const RegisterStartup = () => {
  const { user } = useAuth();
  const router = useRouter();
  const step = isNaN(router.query.step) ? 0 : Number(router.query.step);
  const { state } = useContext(AppContext);
  const { planSubscription, loading } = state;

  //   const beforeEnter = async () => {
  //     if (planSubscription?.has_startup) {
  //       return router.push("/account/startup");
  //     }
  //     try {
  //       if (planSubscription && planSubscription.is_startup_plan) {
  //         if (step <= 1) {
  //           return router.push("?step=2");
  //         }
  //       } else {
  //         return router.push("/");
  //       }
  //     } catch (error) {
  //       return router.push("/");
  //     }
  //   };

  //   useEffect(() => {
  //     if (!loading) {
  //       beforeEnter();
  //     }
  //   }, [loading]);

  //   if (!step || step == "0") {
  //     return null;
  //   }

  return (
    <div className='relative bg-[#F39428] flex items-center overflow-hidden'>
      <StepOne user={user} />
      {/* <StepThree user={user} /> */}
    </div>
  );
};

RegisterStartup.getLayout = (page) => page;

export default RegisterStartup;
